import './App.css';
import React from "react"
import Summary from "./components/Summary"
import Resume from "./components/Resume"
import Contact from './components/Contact';
import Portfolio from './components/Portfolio';

function App() {
  const [currentComponent, setCurrentComponent] = React.useState(<Summary />)
  const [containerClass, setContainerClass] = React.useState("container fade-in")

  const delayTimer = 500;
  function ChangeContainerComponent(component) {
    setContainerClass("container fade-out")
    setTimeout(() => {
      setCurrentComponent(component)
      setContainerClass("container fade-in")
    }, delayTimer);
  }

  function Header() {
    return (
      <div className="header">
          <a onClick={() => ChangeContainerComponent(<Summary />)}>About</a>
          <a onClick={() => ChangeContainerComponent(<Resume />)}>Resume</a>
          <a onClick={() => ChangeContainerComponent(<Portfolio />)}>Portfolio</a>
          <a onClick={() => ChangeContainerComponent(<Contact />)}>Contact</a>
      </div>
    )
  }

  return (
    <div className="App">
      <Header />
      <div className="cover">
        <div className={containerClass}>
          {currentComponent}
        </div>
      </div>
    </div>
  );         
}

export default App;
